import baseV3Service from './base/baseV3Service.js';
import sgtV3Service from './base/sgtV3Service.js';

var CANCEL_REASON;
(function (CANCEL_REASON) {
    CANCEL_REASON["UNAVAILABILITY"] = "unavailability";
    CANCEL_REASON["BY_AGENT"] = "byAgent";
    CANCEL_REASON["BY_PROSPECT"] = "byProspect";
})(CANCEL_REASON || (CANCEL_REASON = {}));
// V3 hooks
// Tours
const createTour = (payload, config) => {
    return sgtV3Service.post("tours", payload, config);
};
const getTour = (config) => {
    return sgtV3Service.get("tours", config);
};
const rescheduleTour = (payload, config) => {
    return sgtV3Service.put("tours", payload, config);
};
const cancelTour = (config) => {
    return sgtV3Service.delete("tours", config);
};
const cancelTourByAgent = (walkaboutId, config) => {
    return sgtV3Service.delete(`walkabouts/${walkaboutId}`, config);
};
const saveProspectData = (payload, config) => {
    return sgtV3Service.post("tours/prospect", payload, config);
};
// Schedules
const getSchedule = (scheduleEntityId, config) => {
    return sgtV3Service.get(`schedules/${scheduleEntityId}`, config);
};
const getScheduleByAgent = (scheduleEntityId, config) => {
    return sgtV3Service.get(`schedules/${scheduleEntityId}`, config);
};
const updateSchedule = (payload, config) => {
    return sgtV3Service.post("schedules", payload, config);
};
const createSchedule = (payload, config) => {
    return sgtV3Service.post("schedules", payload, config);
};
// Access Device
const createAccessDevice = (payload, config) => {
    return baseV3Service.post("sgt/access-device", payload, config);
};
const getAccessDevices = (config) => {
    return baseV3Service.get("sgt/access-device", config);
};
const getAccessDeviceTree = (leafNode, config) => {
    return baseV3Service.get(`sgt/access-device/tree/${leafNode}`, config);
};
const getAccessDeviceDetails = (deviceId, config) => {
    return baseV3Service.get(`sgt/access-device/${deviceId}`, config);
};
const updateAccessDevice = (deviceId, payload, config) => {
    return baseV3Service.put(`sgt/access-device/${deviceId}`, payload, config);
};
const deleteAccessDevice = (deviceId, config) => {
    return baseV3Service.delete(`sgt/access-device/${deviceId}`, config);
};
// Walkabouts
const getWalkabouts = (config) => {
    return baseV3Service.get("sgt/walkabouts", config);
};
const checkInWalkabout = (walkaboutId, config) => {
    return baseV3Service.post(`sgt/walkabouts/${walkaboutId}`, {}, config);
};
const checkInPerimeter = (walkaboutId, config) => {
    return baseV3Service.post(`sgt/perimeter-access/${walkaboutId}`, config);
};
const updateWalkabout = (walkaboutId, payload, config) => {
    return baseV3Service.put(`sgt/walkabouts/${walkaboutId}`, payload, config);
};
const verifyWalkaboutCheckIn = (payload, config) => {
    return baseV3Service.post("/sgt/walkabouts/verify", payload, config);
};
const createSeamConnectWebview = (payload, config) => {
    return baseV3Service.post(`/sgt/seam/connect`, payload, config);
};

export { CANCEL_REASON, cancelTour, cancelTourByAgent, checkInPerimeter, checkInWalkabout, createAccessDevice, createSchedule, createSeamConnectWebview, createTour, deleteAccessDevice, getAccessDeviceDetails, getAccessDeviceTree, getAccessDevices, getSchedule, getScheduleByAgent, getTour, getWalkabouts, rescheduleTour, saveProspectData, updateAccessDevice, updateSchedule, updateWalkabout, verifyWalkaboutCheckIn };
